<ion-content class="login">
  <div class="login__background"></div>
  <div class="login__content">
    <app-logo class="--big --light --desktop-dark login__content__logo"></app-logo>
    <ion-spinner *ngIf="loading$ | async"></ion-spinner>
  </div>
</ion-content>
